/** @jsx h */
import { Component, h, JSX, ComponentChild } from 'preact';
import style from '../index.css';
import { RootStore } from '../../../../../../common/js/stores/root.store';
interface CustomStyles {
  topControls: Record<string, string | number>;
  bottomControls: Record<string, string | number>;
}

interface CrossCloseFullscreenControlsProps {
  ctaCloseItem: ComponentChild;
  ctaExpandItem: ComponentChild;
  customStyles: CustomStyles;
  isInterstitialAdUnit: boolean;
  optOutItem: ComponentChild;
  soundItem: ComponentChild;
}

export class CrossCloseFullscreenControls extends Component<
  CrossCloseFullscreenControlsProps
> {
  render(): JSX.Element {
    const {
      ctaCloseItem,
      ctaExpandItem,
      customStyles,
      isInterstitialAdUnit,
      optOutItem,
      soundItem
    } = this.props;

    const showOptOut = RootStore.getInstance().controlsStore.shouldDisplayOptOut();

    return (
      <div className={style.fullscreenControls}>
        <div
          className={style.fullscreenControlsRow}
          style={customStyles.topControls}
        >
          {soundItem}
          {isInterstitialAdUnit ? ctaCloseItem : ctaExpandItem}
        </div>
        <div
          className={style.fullscreenControlsRow}
          style={customStyles.bottomControls}
        >
          {showOptOut ? optOutItem : <div />}
        </div>
      </div>
    );
  }
}
